(function(){
  'use strict';
  document.documentElement.classList.remove('no-js');

  function qs(s,c){return (c||document).querySelector(s)}
  function qsa(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))}

  function initDrawers(scope){
    qsa('[data-c67-drawer]',scope||document).forEach(function(drawer){
      if(drawer.dataset.c67Ready==='true')return; drawer.dataset.c67Ready='true';
      var id=drawer.id;
      var openers=id?qsa('[data-c67-menu-open][aria-controls="'+id+'"]'):qsa('[data-c67-menu-open]');
      var closer=qs('[data-c67-menu-close]',drawer), overlay=qs('[data-c67-menu-overlay]',drawer), panel=qs('[data-c67-drawer-panel]',drawer);
      var last=null;
      function focusables(){return qsa('a[href],button:not([disabled]),summary,input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])',panel).filter(function(el){return el.offsetParent!==null})}
      function open(){last=document.activeElement;drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');openers.forEach(function(b){b.setAttribute('aria-expanded','true')});document.body.classList.add('c67-drawer-open');if(panel)panel.focus()}
      function close(){drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');openers.forEach(function(b){b.setAttribute('aria-expanded','false')});document.body.classList.remove('c67-drawer-open');if(last&&last.focus)last.focus()}
      function trap(e){if(e.key==='Escape'){close();return}if(e.key!=='Tab'||!drawer.classList.contains('is-open'))return;var list=focusables();if(!list.length)return;var first=list[0],lastEl=list[list.length-1];if(e.shiftKey&&document.activeElement===first){e.preventDefault();lastEl.focus()}else if(!e.shiftKey&&document.activeElement===lastEl){e.preventDefault();first.focus()}}
      openers.forEach(function(b){b.addEventListener('click',open)});
      if(closer)closer.addEventListener('click',close);
      if(overlay)overlay.addEventListener('click',close);
      drawer.addEventListener('keydown',trap);
    })
  }

  function initProductGalleries(scope){
    qsa('[data-c67-product-gallery]',scope||document).forEach(function(gallery){
      if(gallery.dataset.ready==='true')return;gallery.dataset.ready='true';
      var root=gallery.closest('[data-c67-product-root]')||document;
      var main=qs('[data-c67-main-image]',gallery); if(!main)return;
      var lightbox=qs('[data-c67-lightbox]')||qs('.c67-lightbox',root.parentElement||document);
      var lightboxImage=lightbox?qs('[data-c67-lightbox-image]',lightbox):null;
      qsa('[data-c67-thumb]',gallery).forEach(function(button){button.addEventListener('click',function(){
        var src=button.dataset.src, alt=button.dataset.alt||'';
        if(src){main.src=src;main.srcset=button.dataset.srcset||'';main.alt=alt;if(button.dataset.width)main.width=Number(button.dataset.width);if(button.dataset.height)main.height=Number(button.dataset.height);if(lightboxImage){lightboxImage.src=src;lightboxImage.alt=alt}}
        qsa('[data-c67-thumb]',gallery).forEach(function(x){var active=x===button;x.classList.toggle('is-active',active);x.setAttribute('aria-pressed',active?'true':'false')})
      })})
      var opener=qs('[data-c67-lightbox-open]',gallery), closer=lightbox?qs('[data-c67-lightbox-close]',lightbox):null;
      if(opener&&lightbox&&typeof lightbox.showModal==='function')opener.addEventListener('click',function(){if(lightboxImage){lightboxImage.src=main.currentSrc||main.src;lightboxImage.alt=main.alt}lightbox.showModal()});
      if(closer&&lightbox)closer.addEventListener('click',function(){lightbox.close()});
      if(lightbox)lightbox.addEventListener('click',function(e){if(e.target===lightbox)lightbox.close()});
    })
  }

  function money(cents,currency){
    try{return new Intl.NumberFormat(document.documentElement.lang||'en-GB',{style:'currency',currency:currency||'GBP'}).format((Number(cents)||0)/100)}catch(e){return ((Number(cents)||0)/100).toFixed(2)}
  }

  function initVariantForms(scope){
    qsa('[data-c67-variant-form]',scope||document).forEach(function(form){
      if(form.dataset.variantReady==='true')return; form.dataset.variantReady='true';
      var json=qs('[data-c67-product-json]',form); if(!json)return;
      var product; try{product=JSON.parse(json.textContent)}catch(e){return}
      var selects=qsa('[data-c67-option]',form), idInput=qs('[data-c67-variant-id]',form), panel=form.closest('.c67-product2__panel')||form, root=form.closest('[data-c67-product-root]')||document;
      var price=qs('[data-c67-price]',panel), compare=qs('[data-c67-compare]',panel), availability=qs('[data-c67-availability]',panel), btn=qs('[data-add-to-cart]',form), btnText=qs('[data-c67-add-text]',btn), currency=form.dataset.c67Currency||'GBP';
      if(idInput)idInput.disabled=false;
      function update(){
        var values=selects.map(function(s){return s.value});
        var variant=(product.variants||[]).find(function(v){return (v.options||[]).every(function(o,i){return o===values[i]})});
        if(!variant){
          if(idInput)idInput.value='';
          if(price)price.textContent='—';
          if(compare){compare.hidden=true;compare.textContent=''}
          if(availability)availability.textContent='Unavailable';
          if(btn){btn.disabled=true;if(btnText)btnText.textContent=btn.dataset.unavailableLabel||'Unavailable'}
          document.dispatchEvent(new CustomEvent('variant:change',{detail:{variant:null}}));
          return;
        }
        if(idInput)idInput.value=variant.id;
        if(price)price.textContent=money(variant.price,currency);
        if(compare){if(variant.compare_at_price&&variant.compare_at_price>variant.price&&variant.compare_at_price>0){compare.hidden=false;compare.textContent=money(variant.compare_at_price,currency)}else{compare.hidden=true;compare.textContent=''}}
        if(availability)availability.textContent=variant.available?'Available':'Sold out';
        if(btn){btn.disabled=!variant.available;if(btnText)btnText.textContent=variant.available?(btn.dataset.addLabel||'Add to cart'):(btn.dataset.soldLabel||'Sold out')}
        if(variant.featured_image&&variant.featured_image.src){
          var main=qs('[data-c67-main-image]',root);if(main){main.src=variant.featured_image.src;main.srcset='';main.alt=variant.featured_image.alt||main.alt}
        }
        try{var url=new URL(window.location.href);url.searchParams.set('variant',variant.id);window.history.replaceState({},'',url.toString())}catch(e){}
        document.dispatchEvent(new CustomEvent('variant:change',{detail:{variant:variant}}));
      }
      selects.forEach(function(s){s.addEventListener('change',update)}); update();
    })
  }

  function initSort(scope){
    qsa('[data-c67-sort]',scope||document).forEach(function(select){
      if(select.dataset.ready==='true')return;select.dataset.ready='true';
      select.addEventListener('change',function(){var url=new URL(window.location.href);url.searchParams.set('sort_by',select.value);window.location=url.toString()})
    })
  }

  function initFilterPanels(scope){
    qsa('[data-c67-filter-form]',scope||document).forEach(function(form){
      if(form.dataset.c67FilterReady==='true')return;form.dataset.c67FilterReady='true';
      var details=qsa('.c67-filter details',form);
      details.forEach(function(detail){
        detail.addEventListener('toggle',function(){
          if(!detail.open)return;
          details.forEach(function(other){if(other!==detail)other.open=false});
        });
        qsa('[data-c67-filter-close]',detail).forEach(function(button){
          button.addEventListener('click',function(){detail.open=false;var summary=qs('summary',detail);if(summary)summary.focus()});
        });
      });
    });
  }

  function initRecommendations(scope){
    qsa('[data-c67-recommendations]',scope||document).forEach(function(container){
      if(container.dataset.loaded==='true'||!container.dataset.url)return;container.dataset.loaded='true';
      fetch(container.dataset.url,{credentials:'same-origin'}).then(function(r){return r.text()}).then(function(html){var doc=new DOMParser().parseFromString(html,'text/html');var replacement=qs('[data-c67-recommendations]',doc);if(replacement&&replacement.innerHTML.trim()){container.innerHTML=replacement.innerHTML}}).catch(function(){})
    })
  }

  function initAll(scope){initDrawers(scope);initProductGalleries(scope);initVariantForms(scope);initSort(scope);initFilterPanels(scope);initRecommendations(scope)}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){initAll(document)})}else{initAll(document)}
  document.addEventListener('shopify:section:load',function(e){initAll(e.target)});
})();
